module.exports = __webpack_public_path__ + "img/Portafolio Kontakt_1.b7f8e081.png";